import React   from 'react';

class ViewHtml extends React.Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {
	}

	render() {
		return(
			<div className="html-container" dangerouslySetInnerHTML={{__html: this.props.view['html_code']}} />
		);
	}

}

export default ViewHtml;
